import script from "./Aggregation.vue?vue&type=script&setup=true&lang=js"
export * from "./Aggregation.vue?vue&type=script&setup=true&lang=js"

import "./Aggregation.vue?vue&type=style&index=0&id=fcc89a5c&lang=scss"

const __exports__ = script;

export default __exports__